import { render } from "./CoreGoogleLogin.vue?vue&type=template&id=733d7e53&scoped=true"
import script from "./CoreGoogleLogin.vue?vue&type=script&lang=js"
export * from "./CoreGoogleLogin.vue?vue&type=script&lang=js"

import "./CoreGoogleLogin.vue?vue&type=style&index=0&id=733d7e53&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733d7e53"]])

export default __exports__